const normalizeBaseUrl = (value) => value.replace(/\/+$/, "");

const ENV_BASE_URL = process.env.REACT_APP_API_BASE_URL?.trim();
const DEVELOPMENT_FALLBACK = "http://localhost:5001";
const PRODUCTION_FALLBACK = "https://qr-attendance-1-ms69.onrender.com";

const API_BASE_URL = normalizeBaseUrl(
  ENV_BASE_URL ||
    (process.env.NODE_ENV === "development"
      ? DEVELOPMENT_FALLBACK
      : PRODUCTION_FALLBACK),
);

export const apiUrl = (path) =>
  `${API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;

export default API_BASE_URL;
